import { createStore } from "vuex";
import { user, operateStateType } from "./modules/user";
import { tableBar, mobileTableType } from "./modules/tableBar";
import { noticeNewType } from "@/api/request/user";
import { notice } from "./modules/notice";

export default createStore({
  state: {} as {
    user: operateStateType;
    tableBar: mobileTableType;
    notice: {
      newNoticeInfo: noticeNewType;
      newNoticeDialog: boolean;
    };
  },
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    user,
    tableBar,
    notice
  },
});
